import axios from 'axios'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'

NProgress.configure({ showSpinner: false });

const request = axios.create({
    baseURL: 'https://popout.top/api',
    // baseURL: 'http://localhost:3000/api',
    timeout: 10000
})

request.defaults.headers['Access-Control-Allow-Origin'] = '*';
request.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';

// request 拦截器
request.interceptors.request.use(
    config => {
        NProgress.start()
        if (getToken()) config.headers['Authorization'] = `Bearer ${getToken()}`
        return config
    },
    error => {
        NProgress.done()
        return Promise.reject(error)
    }
);

// response 拦截器
request.interceptors.response.use(
    response => {
        NProgress.done()
        let res = response.data;
        if (response.config.responseType === 'blob') {
            return res
        }
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        return res;
    },
    error => {
        NProgress.done()
        console.log('err: ' + error)
        if (error.response) {
            return Promise.reject(error.response.data || error.response)
        }
        return Promise.reject(error.message || error)
    }
)

export default request